import GlobalContext from '../../../../src/contexts/GlobalContext'
import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { Icon, Message } from 'semantic-ui-react'
import { RootDispatch } from "../../../store";

import MomentCustomer from '../../MomentCustomer/MomentCustomer'
import SelectBookingArrivalHour from './SelectBookingArrivalHour'

const mapDispatch = (dispatch: RootDispatch) => ({
  updateBookingByIndex: dispatch.booking.updateBookingByIndex,
})

type Props = {
  booking: any
  bookingIndex: number
} & ReturnType<typeof mapDispatch>

const BookingDateInfos = ({
  booking,
  bookingIndex,
  updateBookingByIndex,
}: Props) => {
  const [globalContext] = useContext(GlobalContext) as any;

  // Update arrivalHour
  const handleUpdateArrivalHour = (newHour) => {
    updateBookingByIndex({ booking: { arrivalHour: newHour }, bookingIndex });
  };

  return (
    <>
      <div className="text-center my-3">
        <span className="mr-3">
          <Icon color="blue" name="male" />
          {booking.paxTotal}
        </span>
        <Icon color="blue" name="calendar alternate" />
        <span>
          {
            <MomentCustomer format="DD MMM">
              {booking.arrivalDate}
            </MomentCustomer>
          }
        </span>
        <Icon color="blue" className="ml-1" name="long arrow alternate right" />
        <span>
          {
            <MomentCustomer format="DD MMM">
              {booking.departureDate}
            </MomentCustomer>
          }
        </span>
        {booking.status === "future" ? (
          <BookingArrivalHour
            booking={booking}
            handleUpdateArrivalHour={handleUpdateArrivalHour}
            translations={globalContext.translations}
          />
        ) : (
          <>
            <Icon color="blue" className="ml-2" name="clock" />
            <span className="mr-2">{booking.arrivalHour ?? "HH:MM"}</span>
          </>
        )}
      </div>
    </>
  );
};

const BookingArrivalHour = ({ booking, handleUpdateArrivalHour, translations }) => {
  return (
    <>
      {!booking.arrivalHour && (
        <div style={{ margin: 10 }}>
          <Message size="mini">
            <label>{translations.askArrivalHour}</label>
            <SelectBookingArrivalHour
              bookingId={booking.id}
              defaultValue={booking.arrivalHour}
              onUpdateSuccess={handleUpdateArrivalHour}
            />
          </Message>
        </div>
      )}
      {booking.arrivalHour && (
        <SelectBookingArrivalHour
          bookingId={booking.id}
          defaultValue={booking.arrivalHour}
          onUpdateSuccess={handleUpdateArrivalHour}
        />
      )}
    </>
  );
};

export default connect(null, mapDispatch)(BookingDateInfos)